import { useTranslation } from "react-i18next";

import { Modal } from "../../../../shared/ui/modal";
import { SessionEventsView } from "../../../session";

interface Props {
    centerId: string;
    /** The session whose history is shown; nothing is open without one. */
    sessionId: string | null;
    /** Who and when, as the agenda row says it, so the panel names its session. */
    heading: string;
    onClose: () => void;
}

/**
 * One session's history for a centre administrator: how it was made, what
 * the patient was sent and when, when it was moved or settled. Read through
 * the centre's route, which only answers for sessions on its agenda.
 */
export default function SessionEventsPanel({ centerId, sessionId, heading, onClose }: Props) {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={sessionId !== null}
            onClose={onClose}
            ariaLabel={t("session.events.title")}
            className="mx-4 w-full max-w-xl rounded-2xl bg-surface-raised p-6"
        >
            <h2 className="pr-12 text-lg font-semibold text-content-primary">{t("session.events.title")}</h2>
            <p className="mb-5 text-sm text-content-tertiary">{heading}</p>
            {sessionId && <SessionEventsView sessionId={sessionId} centerId={centerId} />}
        </Modal>
    );
}
